import { store } from '@redux/store';
import LayoutBreakpoint from 'layout/enums/layoutBreakpoint'
import uiStateSlice from 'layout/redux/uiStateSlice';

/*
 * Handler to set the layout size.
 */
const responsiveLayoutHandler = (event) => {
  if (event.matches) {
    const layoutBreakpoint = LayoutBreakpoint.getLayoutBreakpointByMediaQuery(event.media)
    store.dispatch(uiStateSlice.actions.updateLayoutBreakpoint(layoutBreakpoint));
  }
};

/*
 * Method to configure the listiner when the layout size change.
 */
const configureLayoutHandler = (layoutBreakpoint) => {
  const mediaQueryList = window.matchMedia(layoutBreakpoint.getMediaQuery());
  mediaQueryList.addEventListener('change', responsiveLayoutHandler);
  
  // This invoke is to get the first (onLoad document) layout size of the site.
  responsiveLayoutHandler(mediaQueryList);
}


/*
 * Method to raise the configurations listiners when the layout size change.
 */
const configureLayoutHandlers = () => {
  const layoutBreakpoints = LayoutBreakpoint.toList();
  for (let i = 0; i < layoutBreakpoints.length; i+=1) {
    configureLayoutHandler(layoutBreakpoints[i])
  }
}

configureLayoutHandlers();